import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=2bda0567&scoped=true&"
import script from "./manual.vue?vue&type=script&lang=js&"
export * from "./manual.vue?vue&type=script&lang=js&"
import style0 from "./manual.vue?vue&type=style&index=0&id=2bda0567&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda0567",
  null
  
)

export default component.exports